import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center" data-testid="auth-loading">
        <Loader2 size={40} className="text-isalonuk-accent animate-spin" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/backoffice/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
